import * as React from 'react';
import { AT } from '../../Profile/ProfileFields';
import { styles } from './Styles';

export default ({relationship, firstName}) => (
		<fieldset className={styles.fieldset}>
				<legend className={styles.legend}>Health Information</legend>
				<div>
						<span>Select any assistive technology <b>{relationship == 'myself' ? 'you use' : `used by ${firstName}'`}</b>. You may select as many as are appropriate.</span>
						<AT />
				</div>
		</fieldset>
);



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/Pages/AT.tsx